// Vue
import {Vue, Component, Prop, Inject} from 'vue-property-decorator'

// Template
import template from './template.vue'

// Components
import {Col} from '../col/Col'
import {Row} from '../row/Row'

@Component({
    components: {
        Col,
        Row,
    },
    mixins: [template],
})
export class HeadInfo extends Vue {

    private isTablet: boolean = false

    public created() {

        window.addEventListener('resize', this.handleResize)

        this.handleResize()
    }

    public mounted() {

    }

    public destroyed() {

        window.removeEventListener('resize', this.handleResize)
    }

    private handleResize(e?: Event) {

        const windowWidth = window.innerWidth || document.documentElement!.clientWidth

        this.isTablet = windowWidth >= 768 && windowWidth < 1192 
    }
}
